export const axios500Error =
  "We couldn't process your request. Please try again later.";
export const successMessage = "Your changes have been saved.";
export const loadingError = "Error loading data. Please try again later.";
